export default "\r\n<app-specialization-list></app-specialization-list>\r\n\r\n\r\n";